import React from 'react';
export function Testimonials() {
  return <div className="max-w-3xl mx-auto px-4 py-4" data-id="element-213">
      <h2 className="text-xl font-bold mt-10 mb-6" data-id="element-214">
        Real Results From Men Who Get It
      </h2>
      <div className="bg-gray-50 p-6 rounded-lg mb-6 border border-gray-200" data-id="element-215">
        <div className="flex items-start mb-4" data-id="element-216">
          <div className="mr-4 flex-shrink-0" data-id="element-217">
            <img src="https://cdn.magicpatterns.com/uploads/3T9wK4K4PXM4MJ59wAvwma/Untitled_design_(72).png" alt="Robert K." className="w-16 h-16 rounded-full object-cover" data-id="element-218" />
          </div>
          <div className="flex-grow" data-id="element-219">
            <div className="text-yellow-500 mb-1" data-id="element-220">★★★★★</div>
            <p className="italic" data-id="element-221">
              "Three months in, afternoon crashes are gone. Fasting glucose
              dropped 18 points. My doctor asked what I changed."
            </p>
            <p className="mt-2 font-semibold" data-id="element-222">— Robert K., 59</p>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 p-6 rounded-lg mb-6 border border-gray-200" data-id="element-223">
        <div className="flex items-start mb-4" data-id="element-224">
          <div className="mr-4 flex-shrink-0" data-id="element-225">
            <img src="https://cdn.magicpatterns.com/uploads/fthPEkLhLUAt8e5oyjtfWp/Untitled_design_(71).png" alt="James M." className="w-16 h-16 rounded-full object-cover" data-id="element-226" />
          </div>
          <div className="flex-grow" data-id="element-227">
            <div className="text-yellow-500 mb-1" data-id="element-228">★★★★★</div>
            <p className="italic" data-id="element-229">
              "I spent years thinking I was just getting old. Now I'm sharp all
              day. My business partner noticed the difference."
            </p>
            <p className="mt-2 font-semibold" data-id="element-230">— James M., 64</p>
          </div>
        </div>
      </div>
      <div className="my-8" data-id="element-231"></div>
      <div className="my-8" data-id="element-232"></div>
    </div>;
}